// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__Z8VKX","infoBtn":"quickbooks_infoBtn__3usGk","formBox":"quickbooks_formBox__2LhZo","formFooter":"quickbooks_formFooter__16z-P"};